import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import FlappyBird from './pages/FlappyBird';
import MusicViz from './pages/MusicViz';
import LyricExplorer from './pages/LyricExplorer';
import Lyrical from './pages/Lyrical';
import DelFi from './pages/DelFi/DelFi';
import Blog from './pages/Blog';
import Reina from './pages/Reina';
// import TimelinePage from './pages/TimelinePage';
import GasMeUp from './pages/GasMeUp';
import Betting from './pages/Betting';
import NotFoundPage from './pages/NotFoundPage';
import Stonks from './pages/Stonks/Stonks';
import Rank from './pages/Rank';
import ReinaRank from './pages/ReinaRank';
import Jamie from './pages/Jamie';
import OneYearWrapped from './pages/OneYearWrapped';
import InTheWrong from './pages/InTheWrong';
import InTheWrongAdd from './pages/InTheWrongAdd';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/rank" element={<Rank />} />
        <Route path="/rank/reina" element={<ReinaRank />} />
        <Route path="/jamie" element={<Jamie />} />
        <Route path="/gasmeup" element={<GasMeUp />} />
        <Route path="/betting" element={<Betting />} />
        <Route path="/flappy-bird" element={<FlappyBird />} />
        <Route path="/lyrics" element={<LyricExplorer />} />
        <Route path="/lyrical" element={<Lyrical />} />
        <Route path="/music-viz" element={<MusicViz />} />
        <Route path="/delfi" element={<DelFi />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/in-the-wrong" element={<InTheWrong />} />
        <Route path="/in-the-wrong/add" element={<InTheWrongAdd />} />
        <Route path="/reina" element={<Reina />} />
        <Route path="/reina/one-year" element={<OneYearWrapped />} />
        {/* <Route path="/timeline" element={<TimelinePage />} /> */}
        <Route path="/stonks/*" element={<Stonks />} />

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
}

export default App;